import React, { PureComponent } from 'react';
import { Snackbar } from 'rmwc/Snackbar';
import styled from "styled-components";
import { injectIntl } from "react-intl";

const kDefaultTimeout = 5000,
	kLongTimeout = 10000;


const Wrapper = styled.div`
`;

class Toast extends PureComponent {
	state = {
		visible: false,
		snackbarIsOpen: false
	};

	show(message, actionText, actionHandler) {
		if (this.state.visible) {
			return this.hide(() => {
				this.show(message, actionText, actionHandler);
			});
		}

		this.setState({
			visible: true,
			message,
			actionText, actionHandler
		}, () => {
			setTimeout(() => {
				this.setState({
					snackbarIsOpen: true
				})
			}, 50);

		});
	}

	hide = (callback) => {
		this.setState({
			visible: false,
			message: null,
			snackbarIsOpen: false
		}, callback);
	};

	render() {
		if (!this.state.visible) {
			return <Wrapper/>;
		}

		const ltr = !this.props.intl.locale.includes('he');
		const snackBar = (<Snackbar
			style={ { zIndex: 1000, direction: ltr ? 'ltr' : 'rtl', textAlign: ltr ? 'left' : 'right' } }
			show={ this.state.snackbarIsOpen }
			onHide={ evt => this.hide() }
			message={ this.state.message }
			actionText={ this.state.actionText }
			actionHandler={ () => this.state.actionHandler() }
			dismissesOnAction={ true }
			timeout={ this.state.actionText ? kLongTimeout : kDefaultTimeout }

		/>);

		return (
			<Wrapper>
				{ snackBar }
			</Wrapper>
		)
	}

}

export default injectIntl(Toast, { withRef: true });
